import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 text-center bg-neutral-950 text-white">
      <SEOHead
        title="403 — Adgang nægtet | Casper DJ"
        description="Du har ikke adgang til denne side hos Casper DJ."
      />

      <div className="max-w-md mx-auto space-y-6">
        <div className="w-20 h-20 rounded-2xl bg-gold-400/10 border border-gold-400/30 text-gold-400 flex items-center justify-center mx-auto text-3xl">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <span className="text-xs font-bold uppercase tracking-widest text-gold-400">
          Fejlkode 403
        </span>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Adgang nægtet
        </h1>

        <p className="text-neutral-400 text-sm sm:text-base leading-relaxed">
          Du har ikke tilladelse til at tilgå dette område. Benyt knappen nedenfor for at vende sikkert tilbage.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto px-6 py-3 rounded-xl bg-gold-400 text-neutral-950 font-bold text-xs uppercase tracking-wider hover:bg-gold-300 transition-colors shadow-md"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto px-6 py-3 rounded-xl border border-neutral-800 bg-neutral-900 text-white font-bold text-xs uppercase tracking-wider hover:border-gold-400/50 hover:text-gold-400 transition-colors"
          >
            Kontakt mig
          </Link>
        </div>
      </div>
    </div>
  )
}
